import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-input-text-type',
	templateUrl:'./InputTextTypePluginCompPage.html',
	styles: [],
	styleUrls:['./InputTextTypePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class InputTextTypePluginCompPage
{
	mdContent_988 = `\`\`\`java
import com.jwebmp.core.base.html.inputs.InputTextType;
\`\`\``;
	mdContent_989 = `\`\`\`java
InputTextType()
\`\`\``;
	mdContent_990 = `\`\`\`java
InputTextType&lt;?&gt; input = new InputTextType&lt;&gt;();
input.setPlaceholder("Enter your name");
input.setRequired(true);
input.setMaxLength(100);
\`\`\``;
}
